import { Record } from 'immutable';
import stringHash from 'string-hash';

type PlaceProps = {
  address?: string;
  city?: string;
  label?: string;
  neighborhood?: string;
  state?: string;
  zipCode?: string;
};

export class Place extends Record({
  address: '',
  city: null,
  label: null,
  neighborhood: null,
  state: null,
  zipCode: null,
}) {
  public readonly address!: string;

  public readonly city!: string;

  public readonly label!: string | null;

  public readonly neighborhood!: string | null;

  public readonly state!: string | null;

  public readonly zipCode!: string | null;

  constructor(obj: PlaceProps = {}) {
    let { address = '' } = obj;
    const {
      neighborhood = null,
      city = null,
      label = null,
      state = null,
      zipCode = null,
    } = obj;

    if (!address && city && state) {
      address = [neighborhood, city, state, zipCode, 'United States']
        .filter((f) => f)
        .join(', ');
    }

    super({
      address,
      neighborhood,
      city,
      label: label || `${city}, ${state}`,
      state,
      zipCode,
    });
  }

  equals(other) {
    return (
      this.neighborhood === other.neighborhood &&
      this.city === other.city &&
      this.label === other.label &&
      this.state === other.state &&
      this.zipCode === other.zipCode
    );
  }

  hashCode() {
    return stringHash(`${this.city} ${this.state} ${this.zipCode}`);
  }

  isEmpty() {
    return !this.city || !this.state;
  }

  isValid() {
    const hasNoValue =
      !this.address && !this.city && !this.state && !this.zipCode;
    const hasFullValues = this.address && this.city && this.state;

    return !!(hasFullValues || hasNoValue);
  }
}
